// extracted by mini-css-extract-plugin
export default {"root":"FallbackPage_root__lsdqQ","content":"FallbackPage_content__kjbus"};